module.exports = __webpack_public_path__ + "static/media/tools-pin-open.6c86d222.svg";